import request from "@/api/request.js";

// areaCode
export function getAreaCode(data) {
  return request({
    url: "/getHDAreaCode/GetHDAreaCode",
    method: "post",
    data,
  });
}

// District
export function getDistrict(data) {
  return request({
    url: "/getHDDistrict/GetHDDistrict",
    method: "post",
    data,
  });
}

// Language
export function getLanguage(data) {
  return request({
    url: "/getHDLanguage/GetHDLanguage",
    method: "post",
    data,
  });
}
// Region
export function getRegion(data) {
  return request({
    url: "/getHDRegion/GetHDRegion",
    method: "post",
    data,
  });
}
// register

export function customerRegister(data) {
  return request({
    url: "/hDCustomer/HDCustomer",
    method: "post",
    data,
  });
}
